// This function is used to prevent users going to basket. Why?
// We hijack the onclick event of the basket clicks, and instead of going to basket
// we load the basket page in an iframe
// then make that iframe full width and height of the page
// so we can show our PiP component or do other cool things
// on the basket page.
// We normally wouldn't be able to do that because the page reloads.
// This way we can to add logic to basket page (or other pages if needed) for live commerce users

import { VideoModes } from "src/features/video/model/video-modes";
import { setVideoMode } from "src/features/video/videoSlice";
import projectOptions from "src/shared/project-options";
import { store } from "src/shared/store";
import makeUrl from "src/shared/util/make-url";

let initialDocumentTitle = "";

export default function replaceBasketToInpage() {
  const { basketUrl } = projectOptions.default.network;
  const targetHref = makeUrl(basketUrl).pathname;

  // elements that are linking to basket
  const basketLinks = document.querySelectorAll(`a[href='${targetHref}`);
  document.querySelectorAll("a[href='/baskets/basket/") ||
    document.querySelectorAll("a[href$='/baskets/basket/");

  // elements that are linking to checkout
  const checkoutLinks =
    document.querySelectorAll(`a[href='/orders/checkout/']`) ||
    document.querySelectorAll(`a[href$='/orders/checkout/']`);

  // interrupt navigation.back()
  window.addEventListener("popstate", onPopState);

  // disable basket links & events
  if (basketLinks) {
    basketLinks.forEach((element) => {
      if (element instanceof HTMLAnchorElement) {
        element.href = "#"; // dummy
      }
      if (element instanceof HTMLElement) {
        element.onclick = () => pushBasketPage(targetHref);
      }
    });
  }

  replaceLinkAndEvents(basketLinks, targetHref);
  replaceLinkAndEvents(checkoutLinks, targetHref);
}

function replaceLinkAndEvents(elementsList: NodeList, targetHref: string) {
  if (elementsList) {
    elementsList.forEach((element) => {
      if (element instanceof HTMLAnchorElement) {
        element.href = "#"; // dummy
      }
      if (element instanceof HTMLElement) {
        element.onclick = () => pushBasketPage(targetHref);
      }
    });
  }
}

// toggle PiP when we try to go to a previous page.
// navigating to new pages can't be done with this event
// as the page reloads.
// we need to do it manually for each a element, remove href and click events to basket
const onPopState = (e: any) => {
  const { pathname, basketUrl } = projectOptions.default.network;
  const targetHref = makeUrl(basketUrl).href;

  const nextPath = e.target.location.pathname;
  if (nextPath.includes(targetHref)) {
    pushBasketPage(targetHref);
  } else if (nextPath.includes(pathname)) {
    popBasketPage();
  }
};

function openPictureInPicture() {
  store.dispatch(setVideoMode(VideoModes.PICTURE_IN_PICTURE));
}
function closePictureInPicture() {
  store.dispatch(setVideoMode(VideoModes.NORMAL));
}

//  expects full url to basket page. e.g : https://akinon.net/baskets/basket/
function pushBasketPage(url: string) {
  document.body.classList.add("lc-hide-overflow");

  openPictureInPicture();

  const iframe = document.createElement("iframe");
  iframe.id = "akn-basket-iframe";
  iframe.src = url;

  const containerElement = document.querySelector("body");
  containerElement && containerElement.appendChild(iframe);

  // basket loader
  showSpinner();
  // timeout 10s
  setTimeout(() => {
    hideSpinner();
  }, 10000);
  iframe.addEventListener("load", function () {
    initialDocumentTitle = document.title;
    //  update the document title with the basket iframe title while we are viewing it
    document.title =
      iframe?.contentWindow?.document?.title ||
      iframe?.contentDocument?.title ||
      "Sepet";

    // added route param isLCBasket, so we know its the embedded basket page (iframe)
    window.history.pushState({ isLCBasket: true }, "", url);
    hideSpinner();
  });
}

function popBasketPage() {
  document.body.classList.remove("lc-hide-overflow");

  const iframe = document.querySelector("#akn-basket-iframe");
  if (iframe) {
    document.body.removeChild(iframe);
    closePictureInPicture();
  }
  if (initialDocumentTitle) {
    document.title = initialDocumentTitle;
  }
}

function showSpinner() {
  const spinnerContainer = document.createElement("div");
  spinnerContainer.id = "akn-spinner-container";
  const spinner = document.createElement("div");
  spinner.id = "akn-spinner";
  spinnerContainer.appendChild(spinner);
  document.body.appendChild(spinnerContainer);
}

function hideSpinner() {
  const spinnerContainer = document.querySelector("#akn-spinner-container");
  if (spinnerContainer) document.body.removeChild(spinnerContainer);
}
